/*
 * @Description:
 * @Autor: lwq
 * @Date: 2020-07-14 10:23:40
 * @最后编辑: Please set LastEditors
 * @最后修改时间: 2022-05-11 11:31:47
 * @FilePath: \mrc-ess-fronted\src\util\lang.js
 */
import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);
// 给$t 加 个逻辑    如果没有匹配到对应的key的value就不显示   之前是没有匹配到对应的key的value就显示key
Vue.prototype.$t = function (key) {
  var values = [],
    len = arguments.length - 1;
  while (len-- > 0) values[len] = arguments[len + 1];

  var i18n = this.$i18n;
  return i18n._t.apply(
    i18n,
    [key, i18n.locale, i18n._getMessages(), this].concat(values)
  ) == key
    ? key == ""
      ? ""
      : this.$store.state.isLoading
      ? "****"
      : ("$" + key.substring(key.lastIndexOf("_"), key.length))
          .replace("Label", "")
          .replace("Labbel", "")
    : this.$store.state.viewkey
    ? key
    : i18n._t.apply(
        i18n,
        [key, i18n.locale, i18n._getMessages(), this].concat(values)
      );
};
//常规浏览器语言和IE浏览器默认语言
let lang = navigator.language || navigator.userLanguage;
// 默认语言
const DEFAULT_LANG = lang;

// 存默认语言的key
const LOCALE_KEY = "mrc-ess-base-application-default-lang";

// 获取当前公司目前有的几种语言，没有就默认 简体 繁体 英语
const companyLang = JSON.parse(
  localStorage.getItem("mrc-ess-base-company-lang-lists")
);
let keys = {};
if (companyLang) {
  const value = companyLang.map((item) => {
    return item.value;
  });
  keys = {};
  value.forEach((item) => {
    keys[item] = {};
  });
} else {
  keys = {
    en: {},
    "zh-CN": {},
  };
}

const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: keys,
  silentTranslationWarn: true,
});

export const setup_locale = (lang) => {
  if (!!lang) {
    lang = localStorage.getItem(LOCALE_KEY);
    if (keys[lang] === undefined) {
      lang = DEFAULT_LANG;
    }
  }
  localStorage.setItem(LOCALE_KEY, lang);
  Vue.config.lang = lang;
  i18n.locale = lang;
};
setup_locale(localStorage.getItem(LOCALE_KEY) || DEFAULT_LANG);
export default i18n;
